import { useMemo } from 'react';
import { required } from 'js/utils/Validation/validationRules';
import { IValidationMethodConfigRequired } from 'js/utils/Validation/types';

export const useValidationConfig = () => {
    return useMemo(() => ({
        promoCode: [
            required() as IValidationMethodConfigRequired
        ]
    }), []);
};
